import styles from "./TypingProgress.module.css";

export const TypingProgress = () => {
  return (
    <span className={styles["typing-progress"]}>
      <i>Interviewer is typing</i>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
};
